import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import HeaderTarget from "../../components/HeaderTarget/HeaderTarget";
import FaqRightMenu from "../../components/FaqRightMenu/FaqRightMenu";
import arrowIcon from "./../../assets/arrow.png";
import { useFaqData } from "../../api/useFaqData";
import { useTranslation } from "react-i18next";
import { useSEO } from "../../context/SEOContext";
const FaqCategoryDetailPage = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("faq.meta.title"),
      description: t("faq.meta.description"),
      keywords: t("faq.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);

  const faqData = useFaqData();
  const { faqId } = useParams();

  let foundFaq = null;
  faqData.forEach((category) => {
    const match = category.faqs.find((faq) => faq.id === faqId);
    if (match) {
      foundFaq = match;
    }
  });

  if (!foundFaq) {
    return (
      <>
        <HeaderTarget />
        <div className="container py-5">
          <div className="alert alert-danger text-center" role="alert">
            <h4 className="text-danger">Question not found!</h4>
            Invalid link or the question has been removed. Please try again.
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <HeaderTarget activePage="faq" />
      <div style={{ backgroundColor: "#F8F8F8" }}>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-5 mb-2">
              <a href="/faq">
                <img
                  src={arrowIcon}
                  alt="arrowIcon"
                  width={20}
                  className="mb-3"
                />
              </a>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 mt-3">
              <div className="bg-white w-100 p-4">
                <h3 className="fw-light">{foundFaq.question}</h3>
                <hr />
                <p className="text-muted">{foundFaq.answer}</p>
              </div>
            </div>
            <div className="col-lg-5 mt-3">
              <FaqRightMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqCategoryDetailPage;
